import styled, { createGlobalStyle } from "styled-components";
import Modal from '@iso/components/Feedback/Modal';
import WithDirection from '@iso/lib/helpers/rtl';

export const ConfirmModalStyles = createGlobalStyle`
  .ant-modal-confirm .ant-btn-primary {
    background-color: #0B2A1B !important;
    border-color: #0B2A1B !important;
    &:hover {
      background-color: #0d3322 !important;
      border-color: #0d3322 !important;
    }
  }

  .ant-modal-confirm .ant-btn-default {
    border-color: #0B2A1B !important;
    color: #0B2A1B !important;
    &:hover {
      background-color: #0B2A1B !important;
      border-color: #0B2A1B !important;
      color: #fff !important;
    }
  }

  .ant-modal-confirm .anticon-exclamation-circle {
    color: rgb(245, 34, 45) !important;
  }
`;

const ModalActivityWrap = styled(Modal)`
  .btn-success{
    background-color: #538c53;
    border-color: #538c53;
    &:hover{
      opacity: 0.8;
    }
  }
  .addHazards{
    width: 100%;
    background-color: rgb(63, 63, 68);
    padding: 8px;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 24px;
    color: rgb(255, 255, 255);
    text-align: center;
    height: auto;
    border: transparent;
  }

  .attachLocationBtn{
    width: 100%;
    background-color: #8F9497;;
    padding: 8px;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 24px;
    color: rgb(255, 255, 255);
    text-align: center;
    height: auto;
    border: transparent;
  }

  .ant-timeline-item-head.ant-timeline-item-head-green {
    border-color:rgb(248, 14, 70);
    color: rgb(248, 14, 70);
  }

  .hazard-area-indicator {
    margin-bottom: 10px;
    padding: 8px 12px;
    background: #f6ffed;
    border: 1px solid #b7eb8f;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

`;

export default WithDirection(ModalActivityWrap);
